const environments = {
  signInLink: process.env.GATSBY_SIGN_IN_LINK,
  getPricingLink: process.env.GATSBY_GET_PRICING_LINK,
  facebookLink: process.env.GATSBY_FACEBOOK_LINK,
  instagramLink: process.env.GATSBY_INSTAGRAM_LINK,
  linkedInLink: process.env.GATSBY_LINKEDIN_LINK,
  whatsAppLink: process.env.GATSBY_WHATSAPP_LINK,
  summerLink: process.env.GATSBY_SUMMER_LINK,
  biaLink: process.env.GATSBY_BIA_LINK,
  bacuLink: process.env.GATSBY_BACU_LINK,
  vammoLink: process.env.GATSBY_VAMMO_LINK,
  rurallLink: process.env.GATSBY_RURALL_LINK,
  lucroLink: process.env.GATSBY_LUCRO_LINK,
  linndaLink: process.env.GATSBY_LINNDA_LINK,
  showBlog: process.env.GATSBY_SHOW_BLOG,
  createAccountLink: process.env.GATSBY_CREATE_ACCOUNT_LINK,
  earlyAccessFormLink: "https://forms.fillout.com/t/5p3VAB1NSqus",
  measurementIdC4c7usCom: process.env.GATSBY_MEASUREMENT_ID_C4C7US_COM,
  earlyAccessFormEnglishLink: "https://forms.fillout.com/t/5p3VAB1NSqus",
  earlyAccessFormSpanishLink: "https://forms.fillout.com/t/5p3VAB1NSqus",
  suscribeFormSpanish: process.env.GATSBY_SUSCRIBE_FORM_SPANISH,
  suscribeFormEnglish: process.env.GATSBY_SUSCRIBE_FORM_ENGLISH,
};

export default environments;
